import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Lightbox from 'react-image-lightbox';

import { withClinicalData } from '../contexts/clinicalData';
import { withUser } from '../contexts/user';

import CTAContactUs from '../components/cta/ContactUs';

import ClinicalImage from './results/ClinicalImage';
import ConditionCard from './results/ConditionCard';
import Sidebar from './results/Sidebar';

class Results extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.resolveState(props));
  }

  resolveState(props) {
    const type = props.type || get(props, 'clinicalData.inferenceType') || 'macroscopic';
    const inference = props.clinicalData.inference;

    return {
      image: props.clinicalData.inference.image,
      locations: props.clinicalData.bodyLocation ? props.clinicalData.bodyLocation : null,
      predictions: inference.predictions || [],
      lightboxOpen: false,
      type
    };
  }

  render() {
    const { clinicalData } = this.props;

    const clinicianMode = this.props.user.isClinician;
    const originalImage = get(clinicalData, 'inference.image.url');

    return (
      <React.Fragment>
        <div className="results-view condition-found">
          <div className="results-view__head">
            <div className="container">
              <div className="results-view__head__left">
                <h2>You have {this.state.predictions.length} possible results</h2>
                {/*<p>Review and compare these results. Click on a condition to learn more about causes, treatments and next steps.</p>*/}

                <div className="results-view__head__details">
                  { this.state.image && this.state.image.id &&
                    <div className="submitted-image">
                      <img src={this.state.image.url} onClick={this.openLightbox.bind(this)} />
                    </div>
                  }

                  { this.state.lightboxOpen && (
                    <Lightbox
                      mainSrc={this.state.image.url}
                      enableZoom={false}
                      onCloseRequest={this.closeLightbox.bind(this)}
                    />
                  )}

                  { this.state.locations &&
                    <React.Fragment>
                      <span className="title">Location</span>
                      <span>{ this.bodyLocationsString() }</span>
                    </React.Fragment>
                  }
                </div>
              </div>

              {/*
                  <div className="results-view__head__right">
                  <HeaderButtons />
                  </div>
                */}
            </div>
          </div>

          <div className="with-sidebar-layout">
            <Sidebar
              type={this.state.type}
              predictions={this.state.predictions}
              onItemClick={this.onItemClick.bind(this)}
            />

            <div className="content">
              { clinicianMode &&
                <React.Fragment>
                  <ClinicalImage
                    originalUrl={originalImage}
                    type={this.state.type}
                  />
                </React.Fragment>
              }

              { this.state.predictions.map((prediction, index) => (
                <ConditionCard
                  id={prediction.condition.id}
                  key={prediction.condition.id}
                  index={index + 1}
                  type={this.state.type}
                  condition={prediction.condition}
                  probability={prediction.probability}
                  clinicianMode={clinicianMode}
                />
              ))}
            </div>
          </div>
        </div>

        <CTAContactUs />
      </React.Fragment>
    );
  }

  bodyLocationsString() {
    const bodyLocationsString = this.state.locations.map(l => l.label.toLowerCase()).join(', ');
    return bodyLocationsString.charAt(0).toUpperCase() + bodyLocationsString.slice(1);
  }

  onItemClick(id) {
    const element = document.getElementById(id);

    if (!element) { return; }

    const offset = 20;
    const elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
    const targetPositon = elementPosition - offset;

    window.scrollTo({ top: targetPositon, behavior: 'smooth' });
  }

  openLightbox() {
    this.setState({ lightboxOpen: true });
  }

  closeLightbox() {
    this.setState({ lightboxOpen: false });
  }
}

Results.defaultProps = {};

Results.propTypes = {
  user: PropTypes.object.isRequired,
  clinicalData: PropTypes.object.isRequired,
};

export { Results };
export default withUser(withClinicalData(Results));
